import React from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody,
  Button, FormControl, FormLabel, Input, Select, Flex, Text, Alert, AlertIcon,
  Textarea, Divider,
} from '@chakra-ui/react';
import * as FiIcons from 'react-icons/fi';
import { updateTalent } from '../../../../../store/talents/talentsSlice';
import theme from '../../../../global/theme';

const TITLES = { programmer: 'تعديل المبرمج', designer: 'تعديل المصمم', beta_tester: 'تعديل لاعب البيتا' };

const UpdateModal = ({ category, data, onClose }) => {
  const dispatch = useDispatch();
  const talents = useSelector(state => state.talents);
  const { register, handleSubmit } = useForm({ defaultValues: data });

  const onSubmit = (values) => {
    const fd = new FormData();
    fd.append('_id', data._id);
    fd.append('prev_images', JSON.stringify(data.images || []));
    fd.append('category', category);
    fd.append('name', values.name);
    fd.append('description', values.description);
    fd.append('discord', values.discord || '');
    fd.append('status', values.status);
    if (values.images?.length) {
      Array.from(values.images).forEach(file => fd.append('images', file));
    }
    dispatch(updateTalent(fd)).unwrap().then(() => onClose());
  };

  const inputProps = { bg: theme.light, border: 'none', borderRadius: 4 };

  return (
    <Modal isOpen onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent borderRadius={4} py={4} bg={theme.dark}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader textAlign="center" color="orange" textTransform="uppercase" fontSize={20}>
            {TITLES[category]}
          </ModalHeader>

          <ModalBody>
            {talents.errors.length > 0 && (
              <Alert status="error" variant="left-accent" marginBottom={4}>
                <AlertIcon />
                {talents.errors.map((e, i) => <Text key={i}>{e?.msg}</Text>)}
              </Alert>
            )}

            <FormControl mb={4}>
              <FormLabel color={theme.light} fontSize={13}>الاسم</FormLabel>
              <Input {...inputProps} placeholder="الاسم" {...register('name', { required: true })} />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel color={theme.light} fontSize={13}>الوصف</FormLabel>
              <Textarea {...inputProps} rows={3} placeholder="وصف الشغل" {...register('description', { required: true })} />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel color={theme.light} fontSize={13}>ديسكورد</FormLabel>
              <Input {...inputProps} placeholder="اسم المستخدم أو رابط الدعوة" {...register('discord')} />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel color={theme.light} fontSize={13}>صور إضافية (اختياري)</FormLabel>
              <Input type="file" accept="image/*" multiple {...inputProps} p={1} {...register('images')} />
            </FormControl>

            <Divider borderColor="whiteAlpha.100" mb={4} />

            <FormControl mb={4}>
              <FormLabel color={theme.light} fontSize={13}>الحالة</FormLabel>
              <Select {...inputProps} {...register('status')}>
                <option value="pending">بانتظار الموافقة</option>
                <option value="approved">نشط</option>
                <option value="rejected">مرفوض</option>
              </Select>
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Flex justifyContent="flex-end" gap={3}>
              <Button type="submit" rightIcon={<FiIcons.FiSave />} colorScheme="green"
                isLoading={talents.isLoading}>
                حفظ
              </Button>
              <Button type="button" rightIcon={<FiIcons.FiX />} colorScheme="red"
                isLoading={talents.isLoading} onClick={onClose}>
                إلغاء
              </Button>
            </Flex>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default UpdateModal;
